import { useEffect } from 'react';
import BrowserStorageAccessor from 'common/utils/BrowserStorageAccessor';
import { STORAGE_TYPES } from 'common/constants/constants';
import { TEAM_SPACE_STORAGE_KEYS } from '../team-space.consts';

const STORAGE_TYPE = STORAGE_TYPES.LOCAL;
const storageAccessor = BrowserStorageAccessor()[STORAGE_TYPE];

const useStatePersistance = ({ isInitialized, selectedTeam }) => {
  useEffect(() => {
    if (!isInitialized) return;
    storageAccessor.set(
      TEAM_SPACE_STORAGE_KEYS.TEAM_ID,
      selectedTeam?.id || null
    );
  }, [isInitialized, selectedTeam]);
};

export default useStatePersistance;
